/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:27 GMT
 */
const tokens = {
    component: {
        dropdown: {
            backgroundColor: {
                value: "#ffffff",
                type: "color",
            },
            borderColor: {
                value: "#949494",
                type: "color",
            },
            borderWidth: {
                value: "1px",
                type: "dimension",
            },
            borderRadius: {
                value: "4px",
                type: "dimension",
            },
            paddingHorizontal: {
                value: "16px",
                type: "dimension",
            },
            paddingVertical: {
                value: "8px",
                type: "dimension",
            },
            fontSize: {
                value: "1rem",
                type: "dimension",
            },
            lineHeight: {
                value: "1.25rem",
                type: "dimension",
            },
            fontWeight: {
                value: 400,
                type: "fontWeight",
            },
            height: {
                value: "40px",
                type: "dimension",
            },
            overlay: {
                borderRadius: {
                    value: "4px",
                    type: "dimension",
                },
                backgroundColor: {
                    value: "#ffffff",
                    type: "color",
                },
                boxShadow: {
                    value: {
                        layers: [
                            {
                                inset: false,
                                offsetX: "0px",
                                offsetY: "4px",
                                blur: "24px",
                                spread: "-8px",
                                color: "#00000010",
                            },
                            {
                                inset: false,
                                offsetX: "0px",
                                offsetY: "1px",
                                blur: "6px",
                                spread: "-2px",
                                color: "#00000038",
                            },
                        ],
                        stringValue: "0px 4px 24px -8px #00000010, 0px 1px 6px -2px #00000038",
                    },
                    type: "shadow",
                },
            },
            item: {
                paddingHorizontal: {
                    value: "16px",
                    type: "dimension",
                },
                paddingVertical: {
                    value: "8px",
                    type: "dimension",
                },
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
                fontSize: {
                    value: "1rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 400,
                    type: "fontWeight",
                },
                minHeight: {
                    value: "40px",
                    type: "dimension",
                },
                selected: {
                    backgroundColor: {
                        value: "#e6e6e6",
                        type: "color",
                    },
                },
                hover: {
                    backgroundColor: {
                        value: "#EBEEF2",
                        type: "color",
                    },
                },
                disabled: {
                    color: {
                        value: "#b3b3b3",
                        type: "color",
                    },
                },
            },
            icon: {
                color: {
                    value: "#1e1e1e",
                    type: "color",
                },
            },
            group: {
                fontSize: {
                    value: "0.75rem",
                    type: "dimension",
                },
                lineHeight: {
                    value: "1.25rem",
                    type: "dimension",
                },
                fontWeight: {
                    value: 600,
                    type: "fontWeight",
                },
                textTransform: {
                    value: "uppercase",
                    type: "string",
                },
            },
            large: {
                height: {
                    value: "60px",
                },
            },
        },
    },
};
export default tokens;
